<template>
  <div>
    <main-layout>
      <div>
        <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
          <v-tab href="#dashboard" ripple>{{ $t('Dashboard') }}</v-tab>
          <v-tab
            v-if="selectedBot && selectedBot.pageid == '100207768987988'"
            href="#customersatisfaction"
            ripple
            >{{ $t('Customer Satisfaction') }}</v-tab
          >
          <v-tab
            v-if="![...$store.state.rabbitReplyFBPostPage].includes(selectedBot.pageid)"
            href="#agent"
            ripple
            >{{ $t('Agent View') }}
          </v-tab>
          <v-tab v-if="!['seagull'].includes(selectedBot.theme)" href="#funnel" ripple>{{
            $t('Funnel View')
          }}</v-tab>
          <v-tab
            v-if="[...$store.state.rabbitReplyFBPostPage].includes(selectedBot.pageid)"
            href="#rabbit-agent-performance"
            ripple
          >
            {{ $t('Agent Performance') }}
          </v-tab>
          <v-tab
            v-if="
              ($store.state.privilege &&
                $store.state.privilege.agent_management &&
                !['seagull'].includes(selectedBot.theme)) ||
              (['seagull'].includes(selectedBot.theme) &&
                ['admin'].includes($store.state.privilege.role))
            "
            href="#users"
            ripple
            >{{ $t('Admin/Agent User Management') }}</v-tab
          >
          <v-tab
            v-if="
              selectedBot && ['100207768987988', '102052945584054'].includes(selectedBot.pageid)
            "
            href="#workinghours"
            ripple
            >Working Hours</v-tab
          >
          <v-tab v-if="selectedBot.type === 'nt'" href="#reason" ripple>Reason</v-tab>
        </v-tabs>
        <div :key="currentView"><component :is="currentView" v-if="!loading"></component></div>
        <div style="height: 60px"></div>
      </div>
    </main-layout>
  </div>
</template>

<script>
import Dashboard from './Dashboard'
import Agent from './Agent'
import Funnel from './Funnel'
import Users from './Users'
import customersatisfaction from './CustomerSatisfaction'
import Workinghours from './WorkingHour.vue'
import RabbitAgentPerformance from './RabbitReplyFBPost/AgentPerformance.vue'
import { mapGetters } from 'vuex'
import ReasonList from '../ticket/Reason/ReasonList.vue'
export default {
  components: {
    Dashboard,
    Agent,
    Funnel,
    Users,
    customersatisfaction,
    Workinghours,
    RabbitAgentPerformance,
    reason: ReasonList
  },
  data() {
    return {
      currentView: 'dashboard',
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },

  watch: {
    currentView: function () {
      this.updateRoute()
    }
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      switch (vm.$route.query.tab) {
        case 'dashboard':
        case 'customersatisfaction':
        case 'agent':
        case 'funnel':
        case 'users':
        case 'reason':
          vm.currentView = vm.$route.query.tab
          break
        default:
          vm.currentView = 'dashboard'
          break
      }
    } else {
      vm.currentView = 'dashboard'
    }
  },
  async mounted() {
    this.loading = true
    await this.$store.dispatch('loadAgents')
    await this.$store.dispatch('loadAgentGroups')
    await this.$store.dispatch('loadAgentSubGroups')
    this.loading = false
  },
  methods: {
    updateRoute: function () {
      this.$router.push({
        name: 'ticket',
        path: '/ticket',
        query: {
          tab: this.currentView
        }
      })
      this.routeValue = JSON.stringify(this.$route.query)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/main.vue